import { useParams } from "react-router-dom"
import { Bound } from "lib/@components/binding/Bound"
import { Alert, Stack, Typography } from "@mui/material"
import LoadingScreen from "minimals-template/components/LoadingScreen"
import { getUserAccessBreakdown } from "../controller/get-user-access-breakdown"
import { AccessBreakdown } from "./access-breakdown"

export function UserAccess() {
    // useParams, not useBoundContext: AdministerClientsGuard binds `userId` only on the
    // sfg20-admin route, so the bound value is undefined on the client-admin path
    // (/app/admin/users/:id). The FubspotForUsers panel reads it from bound context and is
    // broken there as a result — not repeating that here.
    const { id: userId } = useParams()
    const breakdown = getUserAccessBreakdown.useResults({ userId })

    if (!breakdown) return <LoadingScreen />

    return (
        <Bound breakdown={breakdown} scope="user" subjectId={userId} clientId={breakdown.clientId}>
            <Stack spacing={2} pt={1}>
                <Alert severity="info">
                    <Typography variant="body2">
                        Everything this user ends up with, and where each demand came from. Client-level entitlements
                        appear here too, because they flow through to the user.
                    </Typography>
                </Alert>
                <AccessBreakdown />
            </Stack>
        </Bound>
    )
}
